import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-shipping',
    templateUrl: './shipping.component.html',
    styleUrls: ['./shipping.component.scss'],
    standalone: false
})
export class ShippingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
